import { c as _c } from "react/compiler-runtime";
interface DentistryIconProps {
  size?: number;
  className?: string;
}
const DentistryIcon = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <g clipPath="url(#clip0_350_9039)"><path d="M20.4337 10.7684C20.5269 9.06577 19.8916 7.12592 18.2313 6.58377M10.8022 23.602C9.52312 21.6367 8.66755 19.4258 8.10846 17.6215C7.63409 16.0713 6.94794 14.5634 5.87212 13.3521C3.83062 11.0565 4.22028 3.72058 9.32829 3.72058C11.6409 3.72058 12.0221 4.9997 14.0043 4.9997C15.9865 4.9997 16.3592 3.72058 18.6803 3.72058C23.7883 3.72058 24.1779 11.0565 22.1364 13.3521C21.0606 14.5634 20.3745 16.0713 19.9001 17.6215C19.3495 19.4173 18.4854 21.6282 17.2063 23.602C16.9183 24.051 16.2152 23.8307 16.2152 23.297C16.2152 20.1797 15.9695 13.8519 14.0043 13.8519C12.039 13.8519 11.7933 20.1797 11.7933 23.297C11.7933 23.8307 11.0987 24.051 10.8022 23.602Z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <defs><clipPath id="clip0_350_9039"><rect width="20" height="21.5587" fill="white" transform="translate(4.00024 2.99988)" /></clipPath></defs>;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t3 || $[5] !== t5) {
    t8 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}</svg>;
    $[4] = t3;
    $[5] = t5;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  return t8;
};
export default DentistryIcon;